import { render, staticRenderFns } from "./PasswordResetRequestConfirmModal.vue?vue&type=template&id=4f532dfb&scoped=true&"
import script from "./PasswordResetRequestConfirmModal.vue?vue&type=script&lang=js&"
export * from "./PasswordResetRequestConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetRequestConfirmModal.vue?vue&type=style&index=0&id=4f532dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f532dfb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
